import { create } from "zustand";

type ProcessStore = {
  reloadFlag: boolean;
  toggleReload: () => void;
};

export const useProcessStore = create<ProcessStore>((set) => ({
  reloadFlag: false,
  toggleReload: () => set((state) => ({ reloadFlag: !state.reloadFlag })),
}));
